import axios from 'axios';
import { BASE_URL } from '../const';

let headers = {
    "Content-Type": 'application/json',
    "Accept": 'application/json',
};

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const token = localStorage.getItem('access_token');

if (token) {
    headers.Authorization = `Bearer ${token}`
}

const api = axios.create({
    baseURL: BASE_URL,
    headers,
    responseType: 'json',
    withCredentials: true,
    // timeout: 5000,
});

api.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

api.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (axios.isCancel(error)) {
        // Requisição foi cancelada, não faça nada ou adicione um log se necessário
        // return Promise.reject('Requisição cancelada.');
        return new Promise(() => {});
    }

    if (axios.isAxiosError(error) && !error.response) {
        return Promise.reject('O sistema está indisponível devido a problemas de rede. Por favor, verifique sua conexão e tente novamente.');
    }

    const { response: { data: { message } } } = error;

    if (message === 'Unauthenticated.') {
        localStorage.removeItem('access_token');
        window.location.href = '/';
    }

    return Promise.reject(error);
});

export default api;
